export const sendCustomEvent = (eventKey: any, eventData?: any) => {
  window.dispatchEvent(new CustomEvent(eventKey, eventData ? { detail: eventData } : undefined));
}